export default "__VITE_ASSET__BAv1FTBg__"